/* p78 · sepet cd blokları: "Bunu da ekle" (cd-cart-upsell) tek tıkla ekleme.
   Shopify.actions.updateCart varsa onu kullanır; Horizon'un sepet bileşenleri (çekmece + sepet sayfası)
   bu olayı dinleyip kendilerini yeniden çizer. Yoksa form normal POST ile /cart/add'e gider (JS'siz yol).
   Hediye çarkı yükleyicisi: kart (snippets/cd-gift-wheel.liquid) sepet yeniden çizilince gelirse içindeki script
   çalışmaz; modül (assets/cd-gift-wheel.js) kart ilk kez görününce buradan bir kez yüklenir. Eşik altındaki
   sepette kart yoktur, modül de yüklenmez. */

const FORM_SELECTOR = 'form[data-cd-upsell-form]';

/** @param {SubmitEvent} event */
async function onSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

  const updateCart = window.Shopify?.actions?.updateCart;
  if (typeof updateCart !== 'function') return; // yerel gönderim

  const idInput = form.elements.namedItem('id');
  const variantId = idInput instanceof HTMLInputElement ? idInput.value : '';
  if (!variantId) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button?.getAttribute('aria-busy') === 'true') return;
  button?.setAttribute('aria-busy', 'true');

  try {
    const result = await updateCart({ lines: [{ merchandiseId: variantId, quantity: 1 }] }, { event: { context: 'cart' } });
    if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
  } catch (error) {
    console.warn('[cd-cart] Sepete eklenemedi, form gönderiliyor:', error);
    form.submit();
    return;
  } finally {
    button?.removeAttribute('aria-busy');
  }
}

const WHEEL_TAG = 'cd-gift-wheel';

/** Sayfada çark kartı varsa modülünü yükler. Yüklendiyse ya da yükleme başladıysa true. */
function loadGiftWheel() {
  if (customElements.get(WHEEL_TAG)) return true;
  const src = document.querySelector(`${WHEEL_TAG}[data-module]`)?.getAttribute('data-module');
  if (!src) return false;
  import(src).catch((error) => console.warn('[cd-cart] Hediye çarkı yüklenemedi:', error));
  return true;
}

function watchGiftWheel() {
  if (loadGiftWheel()) return;
  const observer = new MutationObserver(() => {
    if (loadGiftWheel()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (!window.__cdCartReady) {
  window.__cdCartReady = true;
  document.addEventListener('submit', onSubmit);
  watchGiftWheel();
}
